import { Link } from "react-router-dom";
import FormModalButton from "./FormModalButton";
import PostFormButton from "./PostFormButton";
import FormPageButton from "./FormPageButton";
import Icon from "../../../icons/Icon"
import i18n from "../../../i18n";
import PopUpFormButton from "./PopUpFormButton";
import PopoverFormButton from "./PopoverFormButton"
import { AppSettingsVar } from "../../../_project/settings";

const FormButtonWrapper = ({ 
    id, 
    action_type = null, 
    title = null, 
    element, 
    icon, 
    url, 
    formData,
    className, 
    iconClass='me-1',
    alter_url_func, 
    callbackFunc, 
    disabled = false, 
    field='name', 
    finalizeTag=()=>{}, 
    children,
    ...props 
}) => {

  if(!element) return <span className={className || ''}>{children}</span>
  action_type = action_type || element.action_type
  var return_element = "";
  var url;
  (id) ?  url = element.form_url.replaceAll('<pk>', id) : url = element.form_url;
  (['delete', 'deletes'].includes(element.action)) ? className += ' text-danger '  : className = className;
  (title !== null) ? title = title : title = i18n.t(element.action_name) ;
  if (action_type === "modal" && element.multiple_action) {
    return_element = (
      <FormModalButton
        {...element}
        key={id+title}
        url={url}
        className={className}
        alter_url_func={alter_url_func}
        callbackFunc={callbackFunc}
        disabled={disabled}
        formData={formData}
      >
        {(icon ? <Icon name={element.action_icon} className={iconClass}/> :''  )} 
        {children || title}
        </FormModalButton>
    );
  } else if (action_type === "modal") {
    return_element = (
      <FormModalButton
        {...element}
        key={id+title}
        url={url}
        className={className}
        alter_url_func={alter_url_func}
        callbackFunc={callbackFunc}
        disabled={disabled}
        formData={formData}

      >
        
        {(icon ? <Icon name={element.action_icon} className={iconClass}/> :''  )} 
        {children || title}
      </FormModalButton>
    );
  } else if (action_type === "post_form") {
    return_element = (
      <PostFormButton
        {...element}
        key={id+title}
        url={url}
        className={className}
        alter_url_func={alter_url_func}
        callbackFunc={callbackFunc}
        disabled={disabled}
        formData={formData}
      >
        {(icon ? <Icon name={element.action_icon} className={iconClass}/> :''  )} 
        {children || title}
      </PostFormButton>
    );
  }
  else if (action_type === "page") {
    return_element = (
      <FormPageButton
        {...element}
        key={id+title}
        url={url}
        className={className}
        alter_url_func={alter_url_func}
        callbackFunc={callbackFunc}
        disabled={disabled}
      >
        
        {(icon ? <Icon name={element.action_icon} className={iconClass}/> :''  )} 
        {children || title}
      </FormPageButton>
    );
  } else if (action_type === "inline_page") {
    return_element = (
      <FormPageButton
        {...element}
        key={id+title}
        url={url}
        className={className}
        alter_url_func={alter_url_func}
        callbackFunc={callbackFunc}
        disabled={disabled}
      >
        
        {(icon ? <Icon name={element.action_icon} className={iconClass}/> :''  )} 
        {children || title}
      </FormPageButton>
    );
  } else if (action_type === "navigate") {
    return_element = (
      <Link
        key={id+title}
        to={url.startsWith(AppSettingsVar.portal_prefix) ? url : (AppSettingsVar.portal_prefix + url).replace('//', '/')}
        className={`${className} action-button`}
        alter_url_func={alter_url_func}
        callbackFunc={callbackFunc}
        disabled={disabled}
      >
        {(icon ? <Icon name={element.action_icon} className={iconClass}/> :''  )} 
        {title}
        </Link>
    );
  } else if (action_type === "pop_over") {
    return <PopoverFormButton 
      element={element} 
      url={url} 
      className={className} 
      name={title} 
      field={field}
      finalizeTag={finalizeTag}
    >
    {(icon ? <Icon name={element.action_icon} className={iconClass}/> :''  )} 
    {children || title}
    </PopoverFormButton>

  }else if (action_type === "pop_up") {
    return <PopUpFormButton 
      element={element} 
      url={url.replace('/rest/', '/f/')} 
      className={className} 
      name={title} 
      field={field}
      finalizeTag={finalizeTag}
    >
    {(icon ? <Icon name={element.action_icon} className={iconClass}/> :''  )} 
    {children || title}
    </PopUpFormButton>
  } else if (element.action_type === "external_navigate") {
    const onClick = (url, alter_url_func) => {
      if (alter_url_func) {
        url = alter_url_func(url);
      }
      window.open(url, '_blank');
    }
    return_element = (
      <a
        key={id+title}
        onClick={ ()=> onClick(url, alter_url_func)}
        target="_blank"
        className={className}
        disabled={disabled}
      >
        {(icon ? <Icon name={element.action_icon} className={iconClass}/> :''  )} 
        {children || title}
      </a>
    );
  } 
  
  return return_element
};

export default FormButtonWrapper;
